import React, { Component } from 'react'
import { NewButton } from '../shared/NewButton'
import '../stylesheets/inventory.sass'

export default class NoCustomers extends Component {

    render() {
      return (
        <div className={'welcome-wrapper row'}>
          <div className={'column one'}>
            &nbsp;
          </div>
          <div className={'column two product-welcome'}>
            <div className={'row'}>
              Welcome! It looks like you're new to Kegmeisters.
            </div>
            <div className={'row'}>
              Customers that create reservations show up here.
            </div>
            <div className={'row'}>
              Questions or Comments? Let’s grab a beer! Or give us a call at (970) 946-5380 or email us at hello@kegmeisters.com we’re happy to help.
            </div>
          </div>
          <div className={'column three'}>
            &nbsp;
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Customers/NoCustomers.jsx